import { openBlock as o, createElementBlock as s, normalizeClass as n, toDisplayString as r, createCommentVNode as m, createTextVNode as d, createElementVNode as t } from "vue";
/* empty css                    */
import u from "./design-system.es128.js";
const b = {
  name: "DsToggleSwitch",
  props: {
    /**
     * Make the switch read only.
     */
    readonly: Boolean,
    /**
     * Whether the switch is turned on or off.
     */
    modelValue: Boolean,
    /**
     * The label to show when the switch is on.
     */
    labelOn: String,
    /**
     * The label to show when the switch is off.
     */
    labelOff: String,
    /**
     * Put the toggle label on the other side. Positions are reversed for RTL.
     */
    labelPositionFlip: Boolean
  },
  emits: ["update:modelValue"],
  computed: {
    hasLabels() {
      return !!this.labelOn && !!this.labelOff;
    }
  },
  methods: {
    toggle() {
      this.$emit("update:modelValue", !this.modelValue);
    }
  }
}, g = {
  key: 0,
  class: "label"
}, c = { class: "toggle" }, f = ["value", "disabled"];
function h(V, e, l, _, y, a) {
  return o(), s("label", {
    class: n(["toggle-switch", {
      disabled: l.readonly,
      "no-label": !a.hasLabels,
      "reverse-positioning": l.labelPositionFlip
    }])
  }, [
    a.hasLabels ? (o(), s("span", g, r(l.modelValue ? l.labelOn : l.labelOff), 1)) : m("", !0),
    e[3] || (e[3] = d()),
    t("div", c, [
      t("input", {
        type: "checkbox",
        value: l.modelValue,
        disabled: l.readonly,
        class: n(["visually-hidden", { checked: l.modelValue }]),
        onChange: e[0] || (e[0] = (...i) => a.toggle && a.toggle(...i))
      }, null, 42, f),
      e[1] || (e[1] = d()),
      e[2] || (e[2] = t("span", { class: "slider" }, null, -1))
    ])
  ], 2);
}
const x = /* @__PURE__ */ u(b, [["render", h], ["__scopeId", "data-v-cfabc06e"]]);
export {
  x as default
};
//# sourceMappingURL=design-system.es112.js.map
